import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const SectionContainer = ({ 
  id, 
  bgColor = 'background.default', 
  children, 
  title,
  subtitle,
  textAlign = 'center',
  py = 10,
  maxWidth = 'lg' 
}) => {
  return (
    <Box 
      id={id} 
      sx={{ 
        backgroundColor: bgColor,
        py,
        overflow: 'hidden',
        position: 'relative'
      }}
    >
      <Container maxWidth={maxWidth}>
        {(title || subtitle) && (
          <Box sx={{ mb: 6, textAlign }}>
            {title && (
              <Typography 
                variant="h2" 
                component="h2" 
                gutterBottom
                sx={{ 
                  fontWeight: 'bold',
                  position: 'relative',
                  display: 'inline-block',
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: -10,
                    left: textAlign === 'center' ? '25%' : 0,
                    width: textAlign === 'center' ? '50%' : '80px',
                    height: '4px',
                    bgcolor: 'secondary.main',
                    borderRadius: '2px'
                  }
                }}
              >
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography 
                variant="h6" 
                color="text.secondary" 
                sx={{ mt: 2, maxWidth: textAlign === 'center' ? '800px' : 'auto', mx: textAlign === 'center' ? 'auto' : 0 }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
        )}
        {children}
      </Container>
    </Box>
  );
};

export default SectionContainer; 